module.exports = __webpack_public_path__ + "img/20.f5bc0bc3.jpg";